(() => {
  const addUrl = () => window.Theme?.routes?.cart_add_url || `${window.Shopify?.routes?.root || '/'}cart/add.js`;

  const showSlide = (gallery, requestedIndex) => {
    const slides = [...gallery.querySelectorAll('[data-therawrap-slide]')];
    const thumbs = [...gallery.querySelectorAll('[data-therawrap-thumb]')];
    if (!slides.length) return;
    const index = (requestedIndex + slides.length) % slides.length;

    slides.forEach((slide, slideIndex) => {
      const active = slideIndex === index;
      slide.classList.toggle('is-active', active);
      slide.hidden = !active;
    });

    thumbs.forEach((thumb, thumbIndex) => {
      const active = thumbIndex === index;
      thumb.classList.toggle('is-active', active);
      thumb.setAttribute('aria-pressed', String(active));
    });

    gallery.dataset.activeIndex = String(index);
  };

  const initGallery = (gallery) => {
    if (gallery.dataset.therawrapReady === 'true') return;
    gallery.dataset.therawrapReady = 'true';
    gallery.dataset.activeIndex = '0';

    gallery.querySelectorAll('[data-therawrap-thumb]').forEach((thumb) => {
      thumb.addEventListener('click', () => showSlide(gallery, Number(thumb.dataset.therawrapThumb)));
    });

    gallery.querySelector('[data-therawrap-prev]')?.addEventListener('click', () => {
      showSlide(gallery, Number(gallery.dataset.activeIndex || 0) - 1);
    });

    gallery.querySelector('[data-therawrap-next]')?.addEventListener('click', () => {
      showSlide(gallery, Number(gallery.dataset.activeIndex || 0) + 1);
    });
  };

  const updateVariant = (root, card) => {
    const available = card.dataset.available === 'true';
    const submit = root.querySelector('[data-therawrap-submit]');
    const stickyButton = root.querySelector('[data-therawrap-sticky-button]');
    const price = card.dataset.price || '';

    root.querySelectorAll('[data-therawrap-variant]').forEach((item) => {
      item.classList.toggle('is-selected', item === card);
    });

    const idInput = root.querySelector('[data-therawrap-variant-id]');
    if (idInput) idInput.value = card.dataset.id || '';

    root.querySelectorAll('[data-therawrap-price], [data-therawrap-sticky-price]').forEach((node) => {
      node.textContent = price;
    });

    if (submit) submit.disabled = !available;
    if (stickyButton) {
      stickyButton.disabled = !available;
      stickyButton.textContent = available ? 'Add to cart' : 'Sold out';
    }

    const text = root.querySelector('[data-therawrap-button-text]');
    if (text) text.textContent = available ? 'Add to cart' : 'Sold out';

    const url = new URL(window.location.href);
    url.searchParams.set('variant', card.dataset.id || '');
    window.history.replaceState({}, '', url);
  };

  const initForm = (root) => {
    const form = root.querySelector('[data-therawrap-form]');
    if (!form || form.dataset.therawrapReady === 'true') return;
    form.dataset.therawrapReady = 'true';

    root.querySelectorAll('[data-therawrap-variant] input').forEach((input) => {
      input.addEventListener('change', () => {
        if (input.checked) updateVariant(root, input.closest('[data-therawrap-variant]'));
      });
    });

    form.addEventListener('submit', async (event) => {
      event.preventDefault();
      if (form.classList.contains('is-loading')) return;

      const submit = root.querySelector('[data-therawrap-submit]');
      const stickyButton = root.querySelector('[data-therawrap-sticky-button]');
      const errorNode = root.querySelector('[data-therawrap-error]');
      const formData = new FormData(form);
      formData.delete('therawrap_variant');

      form.classList.add('is-loading');
      if (submit) submit.disabled = true;
      if (stickyButton) stickyButton.disabled = true;
      if (errorNode) errorNode.hidden = true;

      try {
        const response = await fetch(addUrl(), {
          method: 'POST',
          headers: {
            Accept: 'application/json',
            'X-Requested-With': 'XMLHttpRequest',
          },
          body: formData,
        });
        const result = await response.json().catch(() => ({}));
        if (!response.ok) throw new Error(result.description || result.message || 'This item could not be added.');
        window.location.assign(form.dataset.checkoutUrl || '/checkout');
      } catch (error) {
        form.classList.remove('is-loading');
        const selected = root.querySelector('[data-therawrap-variant].is-selected');
        const available = selected?.dataset.available === 'true';
        if (submit) submit.disabled = !available;
        if (stickyButton) stickyButton.disabled = !available;
        if (errorNode) {
          errorNode.textContent = error instanceof Error ? error.message : 'Something went wrong. Please try again.';
          errorNode.hidden = false;
        }
      }
    });

    root.querySelector('[data-therawrap-sticky-button]')?.addEventListener('click', () => {
      form.requestSubmit();
    });

    const sticky = root.querySelector('[data-therawrap-sticky]');
    const submit = root.querySelector('[data-therawrap-submit]');
    if (sticky && submit && 'IntersectionObserver' in window) {
      let purchasePassed = false;
      let footerVisible = false;
      const updateSticky = () => sticky.classList.toggle('is-visible', purchasePassed && !footerVisible);
      const purchaseObserver = new IntersectionObserver(
        ([entry]) => {
          purchasePassed = !entry.isIntersecting && entry.boundingClientRect.top < 0;
          updateSticky();
        },
        { threshold: 0.05 }
      );
      purchaseObserver.observe(submit);

      const footer = document.querySelector('.tw-site-footer');
      if (footer) {
        const footerObserver = new IntersectionObserver(
          ([entry]) => {
            footerVisible = entry.isIntersecting;
            updateSticky();
          },
          { threshold: 0.01 }
        );
        footerObserver.observe(footer);
      }
    }
  };

  const init = (scope = document) => {
    scope.querySelectorAll('[data-therawrap-gallery]').forEach(initGallery);
    scope.querySelectorAll('[data-therawrap-product]').forEach(initForm);
    scope.querySelectorAll('[data-tw-site-header]').forEach((header) => {
      if (header.dataset.therawrapReady === 'true') return;
      header.dataset.therawrapReady = 'true';
      header.querySelector('[data-tw-drawer-close]')?.addEventListener('click', () => {
        header.querySelector('.tw-site-header__drawer')?.removeAttribute('open');
      });
    });
  };

  document.addEventListener('DOMContentLoaded', () => init());
  document.addEventListener('shopify:section:load', (event) => init(event.target));
})();
